/**
 * Legaturile `a[data-spa]` scrise ca HTML in celulele listelor (celula Device
 * din Securitee). Un `<a href="/app/...">` obisnuit reincarca toata aplicatia
 * la fiecare clic; asta il trece prin router. Clicul cu Ctrl/Cmd/Shift, cel din
 * mijloc si `target` raman ale browserului (tab nou, fereastra noua).
 */
export function spaHrefOf(event: MouseEvent): string | null {
  if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return null
  if (!(event.target instanceof Element)) return null
  const a = event.target.closest<HTMLAnchorElement>('a[data-spa]')
  if (!a || (a.target !== '' && a.target !== '_self')) return null
  const href = a.getAttribute('href') ?? ''
  return href.startsWith('/app/') ? href : null
}

let installed = false

/** O singura data pe pagina, langa `installCellDropdowns`; `go` primeste adresa cu tot cu `/app`. */
export function installSpaLinks(go: (href: string) => void): () => void {
  if (installed) return () => {}
  installed = true
  const onClick = (event: MouseEvent) => {
    const href = spaHrefOf(event)
    if (href === null) return
    event.preventDefault()
    go(href)
  }
  document.addEventListener('click', onClick)
  return () => {
    installed = false
    document.removeEventListener('click', onClick)
  }
}
